import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ConstitutionFormStore } from '../../stores/constitution-form.store';

@Component({
  selector: 'app-constitution-deed-object-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CalendarModule,
    InputTextModule,
    DropdownModule,
  ],
  templateUrl: './constitution-deed-object-section.component.html',
  styleUrl: '../../constitution-form.component.scss',
})
export class ConstitutionDeedObjectSectionComponent {
  readonly store = inject(ConstitutionFormStore);
}
